//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import sharedMethods from "../sharedMethods";
import Device from "../classes/Device";
import StandbyBadge from "./Devices/StandbyBadge.vue";

export default {
  computed: {
    ...mapGetters(["allDeviceGroups", "filterDevices"]),
    sharedMethods() {
      return sharedMethods;
    },
  },
  components: { StandbyBadge },
  props: ["openGroups", "searchTerm"],
  data() {
    return {
      deviceToEdit: {},
      modalDeviceDelete: false,
      modalDeviceEdit: false,
      modalGroupEdit: false,
      activeGroupName: null,
      activeGroupId: null,
      activeDevice: null,
    };
  },
  methods: {
    ...mapActions([
      "editDeviceByID",
      "deleteDeviceByID",
      "rebootDeviceByID",
      "fetchDeviceGroups",
      "deleteDeviceGroupByID",
      "updateGroupName",
    ]),

    deleteDeviceGroup(group) {
      console.log(group);
      console.log("MDE SHOULD DELETE " + group + " with GID:" + group.GID);
      this.deleteDeviceGroupByID(group.GID).then((resp) => {
        try {
          if (resp.status == "400") {
            sharedMethods.warnNotify(resp.data);
          }
        } catch (e) {
          console.log(e);
        }
      });
    },

    // copies the device to prevent mutation store objects without using a mutation
    copyDevice(originalDevice) {
      return Device.fromObject(originalDevice.toObject());
    },

    //Device Dropdown Menu Functions------------------------------------------------

    rebootDevice(device) {
      const requestBody = {
        deviceId: device.DID,
      };
      this.rebootDeviceByID(requestBody).then((response) => {
        if (response.data === "Reboot sucessfully scheduled") {
          sharedMethods.successNotify(response.data);
        }
      });
    },

    editDevice(device) {
      const requestBody = {
        accID: this.$store.getters.getUser.AccID,
        deviceID: device.DID,
        deviceName: device.NAME,
      };
      this.editDeviceByID(requestBody).then((response) => {
        if (response.data == "Device updated") {
          sharedMethods.successNotify(response.data);
        }
      });
    },

    async updateGroup() {
      this.updateGroupName({
        accId: this.$store.getters.getUser.AccID,
        groupId: this.activeGroupId,
        groupName: this.activeGroupName,
      }).catch((err) => {
        console.log(err);
      });
      sharedMethods.successNotify("Updated group.");
    },

    deleteDevice(device) {
      this.deleteDeviceByID(device.DID).then((response) => {
        if (response.data == "Device deleted") {
          sharedMethods.successNotify(response.data);
        }
      });
    },

    //------------------------------------------------------------------------------

    getDeviceActiveColor(HEARTBEAT) {
      var currentTime = new Date(Date());
      var deviceHeartbeat = new Date(HEARTBEAT);
      var diff = Math.abs(currentTime - deviceHeartbeat);
      var lastResponse = Math.ceil(diff / 60000);
      var deviceBackgroundColor = "grey";

      if (lastResponse < 5) {
        deviceBackgroundColor = "#00d85b";
      } else if (lastResponse < 30) {
        deviceBackgroundColor = "orange";
      } else if (lastResponse > 30) {
        deviceBackgroundColor = "#d80037";
      }

      var response = "color:" + deviceBackgroundColor;
      return response;
    },
  },
};
